import { ENVIRONMENT, DEPLOYED_ENVIRONMENT } from "./environment";

let ipgsbase = "at4.dyndns.org";
let gestgsbase = "alejandria";
let apligsbase = "ay_dvlcli";
let ejagsbase = "eja";
let puertogsbase = "8121";
let user = "__*webuser";
let pass = "j39199x";

if (DEPLOYED_ENVIRONMENT === ENVIRONMENT.PRODUCTION) {
  ipgsbase = "at4.dyndns.org";
  gestgsbase = "alejandria";
  apligsbase = "ay_clinicas";
  ejagsbase = "aeja";
  puertogsbase = "8121";
}

export const getTokenValidation = (token, onResponse, onError) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("token", token);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/getDataConfirmation.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};

export const setConfirmationAppointment = (
  token,
  confirmationAppointment,
  onResponse,
  onError
) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("token", token);
  urlencoded.append(
    "confirmationAppointment",
    JSON.stringify(confirmationAppointment)
  );

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/setConfirmationAppointment.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};

export const getAvailableDates = (
  dataPatient,
  onResponse,
  onError,
  appointment
) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  const item = {
    idDrList: appointment.idDrList,
    idMo: appointment.idMo,
    idEs: appointment.idEs,
    clientWeb: appointment.clientWeb,
  };

  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("user", user);
  urlencoded.append("pass", pass);
  urlencoded.append("item", JSON.stringify(item));
  urlencoded.append("clientPostman", true);
  urlencoded.append("clientWeb", true);
  urlencoded.append("patient", JSON.stringify(dataPatient));

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/getAvailableDates.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};

export const validateNewPatientAndGetData = (
  dataPatient,
  onResponse,
  onError
) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("user", user);
  urlencoded.append("pass", pass);
  urlencoded.append("clientPostman", true);
  urlencoded.append("clientWeb", true);
  urlencoded.append("newPatient", JSON.stringify(dataPatient));

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/validateNewPatientAndGetData.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};

export const newAppointment = (
  dataPatient,
  appointment,
  onResponse,
  onError
) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("user_gsBase", "jcarlos");
  urlencoded.append("user", user);
  urlencoded.append("pass", pass);
  urlencoded.append("appointment", JSON.stringify(appointment));
  urlencoded.append("newPatient", JSON.stringify(dataPatient));
  urlencoded.append("clientPostman", true);
  urlencoded.append("clientWeb", true);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/newAppointment.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};

export const setPatientFormData = (
  infoPatient,
  questions,
  responsibleMinorData,
  token,
  onResponse,
  onError
) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("ipgsbase", ipgsbase);
  urlencoded.append("gestgsbase", gestgsbase);
  urlencoded.append("apligsbase", apligsbase);
  urlencoded.append("ejagsbase", ejagsbase);
  urlencoded.append("puertogsbase", puertogsbase);
  urlencoded.append("token", token);
  urlencoded.append("infoPatient", JSON.stringify(infoPatient));
  urlencoded.append("questions", JSON.stringify(questions));
  urlencoded.append(
    "responsibleMinorData",
    JSON.stringify(responsibleMinorData)
  );
  urlencoded.append("clientPostman", true);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  fetch(
    "https://ws.latecnologica.com/api//ws-clinicas/setPatientFormData.php",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => onResponse(result))
    .catch((error) => onError(error));
};
